import { motion } from "framer-motion";
import {
  Camera,
  Sparkles,
  Image as ImageIcon,
  ArrowRight,
} from "lucide-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DreamPreviewCarousel from "./components/DreamPreviewCarousel";
import Logo from "../../assets/logo_klikin.png";

const PageHome = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();
  }, []);

  return (
    <div className="relative h-full w-full overflow-hidden bg-[#0f1020] text-white">
      {/* Background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,#8b5cf620,transparent_45%)]" />

      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.15) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.15) 1px, transparent 1px)
          `,
          backgroundSize: "32px 32px",
        }}
      />

      <div className="relative z-10 flex h-full flex-col px-8 py-10">
        {/* Brand */}
        <motion.div
          initial={{ opacity: 0, y: -15 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex justify-center items-center"
        >
          <img src={Logo} className="h-10 w-auto object-fit-contain" />
        </motion.div>

        {/* Hero */}
        <div className="mt-6">
          <motion.h1
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center text-[32px] font-black leading-[0.9]"
          >
            <span className="block uppercase">Step Into Your</span>

            <span className="bg-gradient-to-r from-violet-300 to-cyan-300 bg-clip-text text-transparent">
              DREAM
            </span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.15 }}
            className="mx-auto mt-5 max-w-[320px] text-center text-base leading-7 text-zinc-300"
          >
            Take your photo. Choose your dream.
            <br />
            A unique AI result, created just for you.
          </motion.p>
        </div>

        {/* Flow */}
        <DreamPreviewCarousel />

        <div className="flex-1" />

        {/* CTA */}
        <motion.button
          whileTap={{ scale: 0.98 }}
          whileHover={{ scale: 1.01 }}
          onClick={() => navigate("/question")}
          className="uppercase flex h-[52px] w-full items-center justify-center gap-3 rounded-3xl bg-gradient-to-r from-violet-600 to-violet-500 text-lg font-black shadow-[0_20px_60px_rgba(139,92,246,0.35)]"
        >
          <Sparkles size={22} />
          Let’s Begin
        </motion.button>

        <p className="mt-5 text-center text-xs text-zinc-500">
          Visualize your dream with KLIKIN
        </p>
      </div>
    </div>
  );
};

export default PageHome;